import { Action } from 'redux'
import { CONFIRM_MODAL, SET_MODAL, UNSET_MODAL } from '../constants/modal-const'

export interface SetModal extends Action {
  type: SET_MODAL
  title: string
  message: string
  confirmAction: Action
}

export function setModal(title: string, message: string, confirmAction: Action): SetModal {
  return {
    type: SET_MODAL,
    title,
    message,
    confirmAction,
  }
}

export interface UnsetModal extends Action {
  type: UNSET_MODAL
}

export function unsetModal(): UnsetModal {
  return {
    type: UNSET_MODAL,
  }
}

export interface ConfirmModal extends Action {
  type: CONFIRM_MODAL
}

export function confirmModal(): ConfirmModal {
  return {
    type: CONFIRM_MODAL,
  }
}
